<style scoped lang="scss">
.cons{
  display: none;
}
@media
screen and (max-width: 375px) and (min-width: 374px),
screen and (max-width: 414px) and (min-width: 413px),
screen and (max-width: 640px) and (min-width: 600px),
screen and (min-width: 300px) and (max-width:400px)
{
  .cons{
    display: block!important;
  }
  .effect-lists{
    justify-content: flex-start!important;
  }
  .con{
    display: none!important;
  }
}
.strengths{
  display: flex;
  margin-top: 30px;
  li{
    flex:1;
    text-align: center;
    border-right: 1px solid #eee;
    padding:0 40px;
    &:last-child{
      border: 0;
    }
    h4{
      font-size: 18px;
      margin-bottom: 10px;
      color:#014492;
    }
  }
}
.download{
  display: flex;
  flex-wrap: wrap;
  border-left: 1px solid #E4E6EA;
  li{
    width:50%;
    padding:20px 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #E4E6EA;
    border-right: 1px solid #E4E6EA;
    font-size: 16px;
    cursor: pointer;
    &:nth-of-type(1){
      border-top: 1px solid #E4E6EA;
    }
    &:nth-of-type(2){
      border-top: 1px solid #E4E6EA;
    }
    &:hover{
      color:#014492;
    }
  }
  .btn-primary{
    font-size: 14px;
    span{
      margin-right: 7px;
    }
  }
  .mr41{
    display: block;
  }
  .mr42{
    display: none;
  }
}
.table{
  tr{
    td:first-child{
      background: #F6FAFD;
    }
  }
}
.c-title small{
  margin-top: 10px;
}
.required{
  margin-top: 50px;
  background: none!important;
  margin-left: 0!important;
  font-size: 16px;
}
.desc{
  font-size: 16px;
}
.effect-lists{
  //display: block!important;
  justify-content: space-between;
  flex-wrap:wrap;
  overflow: auto;
}
//.effect-lists1{
//  //display: block!important;
//  justify-content: center;
//  flex-wrap:wrap;
//  overflow: auto;
//}
.compose-type1{
  padding-bottom: 50px;
  background: url("../../assets/img/产品及服务/基因调控/基因编辑/ys_bg.png") no-repeat;
  background-size: 100% 100%;
}
</style>
<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<template>
  <div class="wrap wrap-tec">
    <router-view></router-view>
    <div class="banner con" v-if="!$route.meta.invisibles">
      <img src="@/assets/img/产品及服务/基因调控/基因编辑/banner.png" class="img-fluid">
      <div class="info"></div>
    </div>
    <!---移动端-->
    <div class="banner cons" v-if="!$route.meta.invisibles">
      <img src="@/assets/img/二级标题Banner/基因编辑.jpg" class="img-fluid">
      <div class="info"></div>
    </div>
    <section v-if="!$route.meta.invisibles">
      <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-bottom:  20px;">
        <bread></bread>
      </div>
      <div class="container" style="margin-bottom: 30px;">
        <p class="desc">CRISPR/Cas系统是一种功能强大的基因组编辑工具。CRISPR的全称是 （Clustered Regularly  Interspaced Short Palindromic Repeats），Cas的全称是 （CRISPR-associated），早先是在古细菌中发现的，它为细菌提供适应性免疫。其通过对外源性的 DNA 进行识别、捕获和切割，来起到对抗外源性遗传信息的入侵。其靶向识别并切割靶序列的能力很快就被应用到了科学研究当中，在几年时间内，成为了高效便捷的基因编辑工具。当前应用广泛的就是CRISPR/Cas9系统，其原理是利用gRNA特异性识别靶序列，并引导Cas9核酸内切酶对靶序列的PAM上游进行切割，从而造成靶位点DNA双链断裂，随之利用细胞的非同源末端连接（NHEJ）或同源重组（HDR）的方式对切割位点进行修复，实现DNA水平的敲除、敲入或点突变。</p>
        <div class="gene_img" style="text-align: center"><img src="@/assets/img/产品及服务/基因调控/基因编辑/yl.png"  style="margin-top: 20px;"></div>
      </div>
      <div class="container">
        <div class="c-title con">擎科生物CRISPR/Cas9系列服务项目<small>Tsingke biological CRISPR / cas9 series service project</small></div>
        <div class="c-title cons">擎科生物CRISPR/Cas9系列服务项目<small>Tsingke  CRISPR / Cas9  service </small></div>
        <div class="container con">
          <ul class="effect-lists1 effect-lists">
            <li v-for="(item, index) in types1" :key="index" class="pointer" :class="{active1: currentService === index}" @mouseover="currentService = index" @mouseout="currentService = -1" @click="$router.push(item.ref)">
              <img :src="`/static/img/bj_${item.img}${currentService===index ? '' : ''}.png`">
              <p style="margin-top: 10px;">{{item.name}}</p>
            </li>
          </ul>
        </div>
        <div class="cons" style="margin-top: 20px;">
          <ul class="effect-lists1 effect-lists">
            <li v-for="(item, index) in types1" :key="index" class="pointer"  @click="$router.push(item.ref)">
              <img :src="`/static/img/bj_${item.img}${currentService===index ? '' : ''}.png`" style="width: 60px;">
              <p style="margin-top: 10px;font-size: 12px">{{item.name}}</p>
            </li>
          </ul>
        </div>
      </div>

      <div class="compose-type1" style="margin-top: 100px;">
        <div class="container">
          <div class="c-title">服务优势<small>Service advantage</small></div>
          <div class="neirong" style="display: flex">
            <div class="left ">
              <img src="@/assets/img/产品及服务/基因调控/基因编辑/ys.png" class="img-fluid">
            </div>
            <div class="right">
              <div class="required">
                <p class="mb20">1.根据客户需求，提供定制型实验方案，充分评估项目可行性。</p>
                <p class="mb20">2.拥有先进的平台，掌握基因编辑核心技术。</p>
                <p class="mb20">3.质量保证，稳转细胞株无细菌、真菌及支原体污染，生长状态和表达水平保持稳定。</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="c-title">资源中心<small>Resource center</small></div>
      <div class="container mt30 mb30">
        <ul class="download">
          <li v-for="item in resourcesLists" :key="item.id">
            {{item.name}}
            <el-button type="primary" class="mr41" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
            <el-button type="primary" class="mr41" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>

            <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
            <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>
          </li>
        </ul>
      </div>
      <div class="container">
        <div class="c-title">相关服务<small>Related services</small></div>
        <div class="container" style="width: 100%!important;">
          <div class="con">
            <ul class="effect-lists">
              <li v-for="(item, index) in types" :key="index" class="pointer" :class="{active: currentType === index}" @mouseover="currentType = index" @mouseout="currentType = -1" @click="$router.push(item.ref)">
                <img :src="`/static/img/tk_${item.img}${currentType===index ? '' : ''}.png`">
                <p style="margin-top: 10px;">{{item.name}}</p>
              </li>
            </ul>
          </div>
          <div class="cons" style="margin-top: 20px;">
            <ul class="effect-lists">
              <li v-for="(item, index) in types" :key="index" class="pointer"   @click="$router.push(item.ref)">
                <img :src="`/static/img/tk_${item.img}${currentType===index ? '' : ''}.png`" style="width: 60px;">
                <p style="margin-top: 10px;font-size: 12px">{{item.name}}</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="container">
        <qk-consult type="Virus"/>
      </div>
    </section>
  </div>
</template>
<script>
import { resourceColumns, resourceDownloads } from '@/services/api.index'
import bread from "@/components/bread"
export default {
  components:{
    bread
  },
  data () {
    return {
      currentType: -1,
      currentService: -1,
      types: [
        {name: '基因干扰', img: '2', ref: '/products/Gene_interference'},
        {name: '蛋白表达', img: '3', ref: '/products/Protein_expression'},
        {name: '甲基化检测', img: '4', ref: '/products/Methylation_detection'},
        {name: '基因过表达', img: '5', ref: ''},
        {name: '基因panel定制及SNP分型', img: '6', ref: '/products/Gene_SNP'},
      ],
      types1: [
        {name: 'CRISPRi/CRISPRa服务', img: '4', ref: '/products/CRISPRi_CRISPRa_Applications'},
        // {name: 'sgRNA质粒构建', img: '2', ref: '/products/sgRNA_plasmid_construction'},
        {name: 'sgRNA文库构建', img: '3', ref: '/products/sgRNA_library_construction'},
        {name: 'sgRNA合成', img: '1', ref: '/products/sgRNA_Synthesis'},
      ],
      page: 0,
      total: 0,
      resourcesLists: [],
      categoryId: ''
    }
  },
  created () {
    this.getResourceColumns()
  },
  methods: {
    // 资源栏目
    getResourceColumns () {
      resourceColumns().then(res => {
        this.menuLists = res.data
        this.total = this.baseMethods.getTotal(res)
        this.getResourcesLists(res.data[0].id)
      })
    },
    // 根据栏目id获取资源列表
    getResourcesLists (id) {
      this.categoryId = id
      resourceDownloads(1, this.page, 20).then(res => {
        this.resourcesLists = res.data
        this.total = this.baseMethods.getTotal(res)
      })
    },
    // 下载
    bindDownLoad (imgsrc, name) {
      this.baseMethods.downloadImage(imgsrc, name)
    },
    downFile (item) {
      this.baseMethods.courseDownload(item.resourceFile.visitedUrl, item.name)
    },
    // 翻页
    changePage (value) {
      this.page = value - 1
      this.getResourcesLists(this.categoryId)
    },

  }
}
</script>



// WEBPACK FOOTER //
// src/views/products/Gene_editing.vue